export const sectors = {
  administrative: 'Administrativo',
  financial: 'Financeiro',
  support: 'Suporte Técnico',
};

export function getName(value) {
  return sectors[value];
}
